import { StatusOperations } from './results';

export const DOCUMENT_VALIDATION_SIDES = 'DOCUMENT_VALIDATION_SIDES';

export type DocumentSidesValidationDto = {
  succeed: boolean;
  data: {
    result: StatusOperations;
  };
  source: string;
  mode: string;
};
